var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$features.storiesViewCounts && _vm.viewCount > 0)?_c('div',{staticClass:"view-count d-inline-flex align-items-center pl-2",attrs:{"id":"view-count","data-qa":"view count"}},[_c('span',{staticClass:"icon-ic-view"}),_vm._v("\n  "+_vm._s(_vm.$tc('views.count', _vm.viewCount, { count: _vm.$n(_vm.viewCount) }))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }